import type { BusinessOwnerType } from 'global-intern-types';

const businessOwnerTypes: readonly BusinessOwnerType[] = ['MAN', 'WOMAN', 'COMPANY'];

export default businessOwnerTypes;
